export default "__VITE_ASSET__CFu$EsVk__"